import { JSX, memo } from "react";

interface SpinnerProps {
  className?: string;
  size?: "sm" | "md" | "lg";
  message?: string;
}

const sizeClasses = {
  sm: "h-8 w-8",
  md: "h-12 w-12",
  lg: "h-16 w-16"
};

/** Spinner - Loading indicator with optional message */
export const Spinner = memo(({ className, size, message }: SpinnerProps): JSX.Element => {
  const spinnerClass = className || (size ? sizeClasses[size] : "h-5 w-5");

  const spinnerElement = (
    <svg className={`animate-spin ${spinnerClass}`} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );

  if (message) {
    return (
      <div className="flex flex-col items-center justify-center gap-3">
        {spinnerElement}
        <p className="text-white/80 text-sm font-medium animate-pulse">{message}</p>
      </div>
    );
  }

  return spinnerElement;
});
Spinner.displayName = "Spinner";

export default Spinner;
